import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../lib/cn.js";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary/10 text-primary border-transparent",
        secondary: "bg-muted text-muted-foreground border-transparent",
        success: "border-transparent bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
        warn: "border-transparent bg-amber-500/10 text-amber-700 dark:text-amber-400",
        danger: "border-transparent bg-rose-500/10 text-rose-700 dark:text-rose-400",
        info: "border-transparent bg-sky-500/10 text-sky-700 dark:text-sky-400",
        outline: "border-border text-foreground",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
